import UplevelYourDocumentTitle from "../../../../src/pages/apis/microsoft-PA-integration/uplevel-your-document-title.md";
import UplevelYourDocumentContent from "../../../../src/pages/apis/microsoft-PA-integration/uplevel-your-document-content.md";
import BenefitsForEnterprises from "../../../../src/pages/apis/microsoft-PA-integration/benefits-for-enterprises.md";
import GetHelpBlade from "../../../../src/pages/apis/microsoft-PA-integration/get-help-blade.md";
import GetStarted from "../../../../src/pages/apis/microsoft-PA-integration/getStarted.md";
import AdditionalResources from "../../../../src/pages/apis/microsoft-PA-integration/additional-resources.md";
import MsAnnouncementBlock from "../../../../src/pages/apis/microsoft-PA-integration/ms-announcement.md";
import * as React from 'react';
export default {
  UplevelYourDocumentTitle,
  UplevelYourDocumentContent,
  BenefitsForEnterprises,
  GetHelpBlade,
  GetStarted,
  AdditionalResources,
  MsAnnouncementBlock,
  React
};